// @ts-strict

import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PrivateChatService } from '@app/core/services/private-chat/private-chat.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { PanelHeaderItem } from '../panel-header.component';
import { MAIN_WEBSITE_URL } from '@app/core/helpers/constants';

const pageToOpen = MAIN_WEBSITE_URL + 'en/blog';

@Component({
  selector: 'app-category',
  templateUrl: './category.component.html',
  styleUrls: ['./category.component.scss']
})
export class CategoryComponent {
  @Input() item?: PanelHeaderItem;
  @Input() activeItem?: string;
  @Input() component?: string;

  @Output() emitClickedItem: EventEmitter<string> = new EventEmitter();

  public isActive = false;

  public get supportPanel(): boolean {
    return this.component === 'support';
  }

  public get faqPanel(): boolean {
    return this.component === 'faq';
  }

  public get conversationsPanel(): boolean {
    return this.component === 'conversations';
  }

  constructor(private readonly activeModal: NgbActiveModal, public privateChat: PrivateChatService) {}

  public clickedItem(): void {
    if (this.item) {
      if (this.item.name === 'guides') {
        window.open(pageToOpen, '_blank');
        this.activeModal.close();
      }

      this.isActive = !this.isActive;
      this.emitClickedItem.emit(this.item.name);
    }
  }
}
